import { FiX } from 'react-icons/fi';
import styles from './Modal.module.css';

const Modal = ({ onClose, showClose = true, centered = false, children }) => {
    return (
        <div className={styles.overlay} onClick={onClose}>
            <div
                className={`${styles.modal} p-4 p-md-5 ${centered ? 'text-center' : ''}`}
                onClick={(event) => event.stopPropagation()}
            >
                {showClose && (
                    <button type="button" className={styles.closeButton} aria-label="Close" onClick={onClose}>
                        <FiX size={22} />
                    </button>
                )}
                {children}
            </div>
        </div>
    );
};

export const ModalTitle = ({ children, className = '' }) => {
    return <h3 className={`${styles.title} ${className}`}>{children}</h3>;
};

export const ModalSubtitle = ({ children, className = '' }) => {
    return <p className={`${styles.subtitle} ${className}`}>{children}</p>;
};

export const ModalDivider = () => {
    return <hr className={styles.divider} />;
};

export const DetailRow = ({ label, children, className = '' }) => {
    return (
        <div className={`d-flex align-items-center ${className}`}>
            <span className={styles.detailLabel}>{label}</span>
            {children}
        </div>
    );
};

export default Modal;
